import { useState } from 'react';
import { IUseModalFlag } from './types';

const useModalFlag = (): IUseModalFlag => {
  const [flag, setFlag] = useState<boolean>(false);
  const setModalFlag = (): void => {
    setFlag((prev) => !prev);
  };

  return { flag, setModalFlag };
};

export default useModalFlag;
